// i18n area 'storage' — locale de-DE (task #171, onda 1): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/storage.de-DE.meta.json.
import type { enUS } from './storage'

export const deDE: typeof enUS = {
  storage: {
    pools: {
      title: 'Storage',
      createTitle: 'Storage erstellen',
      path: 'Pfad',
      pathHint: 'Absoluter Pfad unter einer erlaubten Root (Default /var/lib/tvirt/pools/)',
      shared: 'Geteilter Storage',
      sharedChip: 'geteilt',
      sharedVerifiedChip: 'geteilt · verifiziert',
      sharedVerifiedTooltip: 'Teilung verifiziert: Kreuzweise Sonden bestätigen, dass jedes Mitglied die von den anderen geschriebenen Daten sieht.',
      sharedDisputedChip: 'geteilt · NICHT verifiziert',
      sharedDisputedTooltip: 'Teilung NICHT verifiziert',
      sharedDisputedPair: '{observer} sieht die von {writer} geschriebenen Daten nicht',
      sharedHint: 'Ein Netzwerk-Share, lokal am selben Pfad auf jedem Mitglied gemountet — die Voraussetzung der Live Migration (deklarativ).',
      sharedDanger: 'GEFAHR — TVirt GLAUBT diesem Flag: Wird es eingeschaltet, nimmt jedes Mitglied an, an diesem Pfad DIESELBEN Bytes zu sehen. Auf einem Verzeichnis, das KEIN wirklich geteilter Share ist (NFS/CIFS/Cluster-Filesystem), sind das Ergebnis Korruption und Datenverlust bei der ersten Migration oder dem ersten HA-Neustart auf einem anderen Knoten. Schalten Sie es nur ein, wenn der Pfad ein auf jedem Knoten identisch gemounteter Share ist.',
      type: 'Typ',
      capacity: 'Kapazität',
      provisioned: 'Allokiert',
      provisionedOvercommit: 'Potenzielle Belegung über die Kapazität hinaus: Die Thin-Volumes können bis auf {n} GiB wachsen.',
      phase: { ready: 'Bereit', degraded: 'Degradiert', error: 'Fehler' },
      tabConfig: 'Konfiguration',
      tabCapacity: 'Kapazität und Zustand',
      cardIdentity: 'Identität',
      cardPlacement: 'Platzierung',
      cardConnection: 'Verbindung',
      usedReal: 'Reale Belegung',
      capacityUnknown: 'Der Knoten hat die Kapazität dieses Pools noch nicht gemeldet — hier werden keine Zahlen erfunden',
      overcommitHint: 'Belegung über der Kapazität: legitim auf Thin-Pools, behalten Sie die reale Belegung im Auge',
      supportedContent: 'Unterstützte Inhalte',
      content: {
        disks: 'Festplatten',
        catalogFiles: 'Katalogdateien',
        backups: 'Backups',
        appVolumes: 'App-Volumes'
      },
      defaultDiskFormat: 'Standard-Festplattenformat',
      reserveGiB: 'Reservierter freier Platz (GiB)',
      available: 'Verfügbar',
      diskCount: 'Festplatten',
      filesystem: 'Filesystem',
      observedAt: 'Beobachtet am',
      lostAtRow: 'Für verloren erklärt am',
      sharedProbeRow: 'Verifikation der Teilung',
      sharedProbeNodes: 'Sondierte Knoten',
      reachableFrom: 'Deklarierte Erreichbarkeit',
      reachableFromHint: 'Die Knoten, von denen dieser Storage erreichbar sein muss. Eine VM, deren Festplatten, ISOs oder Metadaten hier liegen, startet und migriert nicht auf einen Knoten außerhalb dieser Liste. Alle Mitglieder sind vorausgewählt: Schränken Sie nach Belieben ein. Ein Knoten, der dem Cluster später beitritt, bleibt außen vor, bis Sie ihn hier hinzufügen.',
      reachableFromNone: 'nicht deklariert',
      reachableFromTags: 'Erreichbarkeit per Tag',
      reachableFromTagsHint: 'Selektor tag=Wert (kommagetrennte Einträge, UND-verknüpft): jedes Mitglied mit diesen Tags gilt als erreichbar erklärt — dynamisch: einen Knoten taggen nimmt ihn auf.',
      reachableFromTagsInvalid: 'Ungültiges Format — tag=Wert verwenden, kommagetrennt',
      reachableResolved: 'Aufgelöste Knoten: {nodes}',
      reachableDeclaredNotSeen: 'deklariert, aber von der Teilungs-Sonde nicht gesehen auf: {nodes}',
      reachableSeenNotDeclared: 'gesehen, aber nicht deklariert (außerhalb des Perimeters) auf: {nodes}',
      cephCluster: 'Verwalteter Ceph-Cluster',
      appGuardTitle: 'Storage in Benutzung durch Apps',
      appEphemeralGuard: 'dieser Storage ist der ephemere Cluster-Pool der Apps — ändern Sie ihn zuerst auf der Apps-Seite, dann löschen Sie ihn.',
      appInUseGuard: 'hier leben App-Roots/-Volumes: {apps} — verschieben oder löschen Sie sie zuerst.',
      releaseRequiredTitle: "'{name}' löschen und seine Images freigeben?",
      releaseRequiredBatchTitle: 'Die ausgewählten Storages löschen und ihre Images freigeben?',
      releaseRequiredBody: 'Das Freigeben der Images löscht KEIN Byte: die Abmeldung lässt den Namespace auf der Platte, die Images sind einfach nicht mehr materialisiert und jede Referenz der Scopes überlebt als Claim — wird der Pool erneut registriert, werden sie wieder adoptiert.',
      releaseConfirm: 'Löschen und Images freigeben'
    },
    lost: {
      chip: 'Verloren',
      action: 'Für verloren erklären',
      confirmTitle: 'Storage für verloren erklären',
      confirmBody: 'Operator-Attestierung auf eigenes erklärtes Risiko: Jeder wartende oder laufende Task auf diesem Storage oder seinen Objekten wird FEHLSCHLAGEN, Löschungen erfolgen nur noch im Register (keine Filesystem-Arbeit) und neue physische Arbeit wird abgelehnt. Die Bytes werden nie angefasst — kommt das Volume wieder zum Leben, registrieren Sie es erneut und führen Sie einen Scan aus, um alles wieder zu adoptieren.',
      confirmSubmit: 'Für verloren erklären',
      error: 'Die Attestierung wurde abgelehnt'
    },
    findings: {
      action: 'Gefundene Objekte',
      title: 'Gefundene Objekte',
      empty: 'Kein Objekt im Namespace des Storage gefunden',
      loadError: 'Die gefundenen Objekte konnten nicht geladen werden',
      actionError: 'Die Entscheidung wurde abgelehnt',
      colKind: 'Typ',
      colObject: 'Objekt',
      colConflict: 'Konflikt',
      namespaceNotice:
        'Dieses Verzeichnis war bereits von einem anderen Storage initialisiert: Das Identitätssiegel wurde mit dem dieses Storages überschrieben. Die Inhalte wurden NICHT angetastet — sieh dir die unten gefundenen Objekte an, importiere die benötigten und schließe dann diesen Hinweis.',
      kind: {
        disk: 'Festplatte',
        catalogFile: 'Katalogdatei',
        vmMetadata: 'VM-Metadata',
        namespace: 'Namespace',
        foreign: 'Fremd',
        volumeGroup: 'Volume Group'
      },
      vgAdopt: {
        action: 'Volume Group adoptieren',
        title: 'Volume Group adoptieren',
        intro:
          'Dieses Gerät trägt bereits eine Volume Group mit einem TVirt-Namen, aber ihr Siegel nennt kein hier registriertes Storage. Es kann sein, was ein früheres Storage DIESES Clusters auf der LUN hinterlassen hat — oder was EIN ANDERER TVirt-Cluster auf einer weitergereichten LUN hinterlassen hat: von hier aus sehen beide Fälle identisch aus, und deshalb entscheidet niemand für Sie.',
        irreversible: 'Sehen Sie sich Gerät, Siegel und Namen an, bevor Sie fortfahren: Die Adoption lässt sich nicht rückgängig machen.',
        device: 'Gerät',
        seal: 'Siegel',
        sealNone: 'keines (kein tvirt.storageId-Tag)',
        renameTo: 'Wird umbenannt in',
        renameNone: 'Keine Umbenennung: Der Name ist bereits der, den dieses Storage ableitet',
        volumesNote:
          'Die enthaltenen Volumes werden durch diese Geste NICHT adoptiert: Der nächste Scan bietet sie einzeln an, als gewöhnliche gefundene Objekte.'
      },
      conflictChip: 'ID existiert bereits',
      dismissedChip: 'Ignoriert',
      adopt: 'Adoptieren',
      adoptFileTitle: 'In einen Katalog importieren',
      adoptFileHint: 'Dateien existieren nur innerhalb von Katalogen: Wählen Sie den Zielkatalog für die gefundene Datei.',
      purge: 'Von der Festplatte löschen',
      dismiss: 'Ignorieren',
      purgeConfirmTitle: 'Von der Festplatte löschen',
      purgeConfirmBody: 'Die gefundenen Bytes von {id} werden vom Storage entfernt. Das lässt sich nicht rückgängig machen.',
      taskStarted: 'Gestartet — läuft als Task im Hintergrund weiter',
      scan: 'Storage scannen',
      scanStarted: 'Scan gestartet…',
      scanDone: 'Scan abgeschlossen — die gefundenen Objekte sind aktuell'
    },
    reinit: {
      action: 'Initialisierung erneut versuchen'
    },
    wizard: {
      addButton: 'Hinzufügen',
      title: 'Storage hinzufügen',
      back: 'Zurück',
      continue: 'Weiter',
      selectHint: 'Wählen Sie ein Protokoll, um zu sehen, wie TVirt es nutzt.',
      roadmap: 'Roadmap',
      server: 'Server',
      export: 'Exportierter Pfad',
      share: 'Share',
      username: 'Benutzername',
      password: 'Passwort',
      passwordHint: 'Nur Schreiben: für den Mount verwendet, nie wieder angezeigt.',
      credential: 'Zugangsdaten',
      credentialManual: 'Manuell eingeben',
      credentialHint: 'Ein Keystore-Eintrag vom Typ Benutzername und Passwort — die Alternative dazu, sie hier einzutippen.',
      credentialEmpty: 'Keine Zugangsdaten vom Typ Benutzername und Passwort im Keystore — legen Sie welche unter System → Zugangsdaten an, oder tippen Sie das Konto unten ein.',
      options: 'Mount-Optionen',
      optionsHint: 'Kommagetrennt, wörtlich an mount -o durchgereicht.',
      portal: 'Portal',
      portalHint: 'host[:port] — der Standard-Port ist 3260.',
      target: 'Target-IQN',
      targetHint: 'Der Name des iSCSI-Targets, beginnt mit iqn.',
      lun: 'LUN',
      wholeLunRow: 'Auf den Datenträgern: dieser Storage nennt nur das Target',
      wholeLunHint: 'Dieser Storage nennt nur das Target: seine LUNs werden einzeln zu Datenträgern (Datenträger anlegen → ganze LUN übernehmen), auf das Target wird nichts geschrieben.',
      lunHint: 'LUN-Nummer auf dem Target — im Zweifel 0.',
      chapCredential: 'Zugangsdaten (CHAP)',
      chapCredentialHint: 'Ein Keystore-Eintrag vom Typ CHAP (iSCSI), verwendet für den Login — das Geheimnis reist nie mit dem Storage.',
      chapNone: 'Keine Authentifizierung',
      chapEmpty: 'Keine Zugangsdaten vom Typ CHAP (iSCSI) im Keystore — legen Sie welche unter System → Zugangsdaten an. Ohne bleibt der Login unauthentifiziert.',
      address: 'Adresse',
      addressHint: 'Host oder IP des NVMe/TCP-Targets (traddr).',
      port: 'Port',
      portHint: 'TCP-Port des Targets — 4420, wenn leer gelassen.',
      targetNqn: 'Target-NQN',
      targetNqnHint: 'Der NQN des Subsystems auf dem Target, beginnt mit nqn.',
      nsid: 'NSID',
      nsidHint: 'Namespace-ID innerhalb des Subsystems — im Zweifel 1.',
      dhchapCredential: 'Zugangsdaten (DH-HMAC-CHAP)',
      dhchapCredentialHint: 'Ein Keystore-Eintrag vom Typ DH-HMAC-CHAP (NVMe), verwendet beim Verbinden — das Geheimnis reist nie mit dem Storage.',
      dhchapNone: 'Keine Authentifizierung',
      dhchapEmpty: 'Keine Zugangsdaten vom Typ DH-HMAC-CHAP (NVMe) im Keystore — legen Sie welche unter System → Zugangsdaten an. Ohne bleibt die Verbindung unauthentifiziert.',
      monitors: 'Monitore',
      monitorsHint: 'Endpoints der Ceph-Monitore, host[:port], durch Komma oder Zeilenumbruch getrennt — Standard-Port 6789.',
      pool: 'Pool',
      poolHint: 'Der zu konsumierende RBD-Pool — ein RBD-Image je Festplatte.',
      fs: 'Filesystem',
      fsHint: 'Der Name des CephFS-Filesystems (mds_namespace beim Mount).',
      fsPath: 'Pfad innerhalb des Filesystems',
      fsPathHint: 'Absoluter Pfad innerhalb des Filesystems, den der Storage mountet — im Zweifel /.',
      cephxCredential: 'Zugangsdaten (cephx)',
      cephxCredentialHint: 'Ein Keystore-Eintrag vom Typ cephx: username = Client-Name (client.…), secret = der Base64-Schlüssel. Erforderlich.',
      cephxNone: 'Keine cephx-Zugangsdaten im Keystore — legen Sie welche an (Typ: cephx) unter System → Zugangsdaten, oder lassen Sie einen verwalteten Ceph-Cluster sie über "Als Storage vorschlagen" prägen.',
      sharedByNature: 'Netzwerk-Storages sind von Natur aus geteilt: Jedes Mitglied mountet sie am selben von TVirt verwalteten Pfad.',
      error: 'Der Storage wurde abgelehnt',
      category: {
        nas: 'NAS',
        san: 'SAN',
        ceph: 'Ceph',
        other: 'Andere',
        legacy: 'Legacy'
      },
      legacyHint: 'Voll unterstützt — wir würden sie nur für eine neue Installation nicht mehr wählen.',
      proto: {
        dir: {
          name: 'Lokaler Ordner',
          desc: 'Ein Verzeichnis des Knotens: einfach und schnell. Es ist LOKAL zu einem Knoten, außer der Pfad ist ein wirklich geteilter Share — ihn als geteilt zu markieren, wenn er es nicht ist, kostet Daten.',
          usage: 'TVirt bewahrt darin VM-Festplatten, ISO-/Disk-Images und Templates auf.'
        },
        nfs: {
          name: 'NFS',
          desc: 'Ein NFS-Export, vom Cluster gemountet — von Natur aus geteilt.',
          usage: 'Beherbergt VM-Festplatten, ISO-/Disk-Images und Templates.'
        },
        cifs: {
          name: 'CIFS/SMB',
          desc: 'Ein Windows-/Samba-Share, vom Cluster gemountet — von Natur aus geteilt.',
          usage: 'Beherbergt VM-Festplatten, ISO-/Disk-Images und Templates.'
        },
        sftp: {
          name: 'SFTP',
          desc: 'Ein entferntes Filesystem über SSH — ohne dass ein NAS-Export nötig wäre.',
          usage: 'Auf der Roadmap.'
        },
        iscsi: {
          name: 'iSCSI',
          desc: 'Block-LUNs über IP mit geteiltem LVM darüber.',
          usage: 'Nur Festplatten — ein Thin-Volume je Festplatte; beherbergt weder ISO-Images noch Templates.'
        },
        rbd: {
          name: 'Ceph RBD',
          desc: 'Verteilte Block-Devices auf einem Ceph-Cluster.',
          usage: 'Nur Festplatten — ein RBD-Image je Festplatte, nativ von QEMU geöffnet; beherbergt keine ISO-Images.'
        },
        cephfs: {
          name: 'CephFS',
          desc: 'Das verteilte Filesystem von Ceph, vom Kernel auf dem Cluster gemountet — shared by nature.',
          usage: 'Beherbergt VM-Festplatten, ISO-/Disk-Images und Templates — die dir-Familie auf einem Ceph-Filesystem (cephx-Zugangsdaten erforderlich).'
        },
        fc: { name: 'SCSI/FC', desc: 'SCSI-LUNs über eine FibreChannel-Fabric — die klassische FC-SAN.' },
        fcoe: { name: 'SCSI/FCoE', desc: 'Dasselbe SCSI über FibreChannel, mit den FC-Frames in Ethernet gekapselt.' },
        'iscsi-lun': {
          name: 'iSCSI (ganze LUNs)',
          desc: 'Das iSCSI-Target als Träger ganzer LUNs: jeder Datenträger IST eine LUN, roh an den Gast durchgereicht — kein LVM dazwischen.',
          usage: 'Nur Datenträger — eine ganze LUN pro Datenträger, wie sie ist übernommen; das SAN-Zuhause der gemeinsam beschreibbaren Datenträger.'
        },
        'nvme-tcp-lun': {
          name: 'NVMe/TCP (ganze Namespaces)',
          desc: 'Das NVMe-Subsystem als Träger ganzer Namespaces: jeder Datenträger IST ein Namespace, roh an den Gast durchgereicht.',
          usage: 'Nur Datenträger — ein ganzer Namespace pro Datenträger, wie er ist übernommen; gemeinsames Schreiben ja, SCSI Persistent Reservations nein.'
        },
        'nvme-tcp': {
          name: 'NVMe/TCP',
          desc: 'Entferntes NVMe — kein SCSI im Pfad — über schlichtes TCP, mit geteiltem LVM darüber.',
          usage: 'Nur Festplatten — ein Thin-Volume je Festplatte; beherbergt weder ISO-Images noch Templates.'
        },
        nvmefc: { name: 'NVMe/FC', desc: 'Entferntes NVMe über eine FibreChannel-Fabric.' },
        nvmefcoe: { name: 'NVMe/FCoE', desc: 'NVMe über die FibreChannel-Fabric, die FCoE in Ethernet transportiert — die Layer FCoE und NVMe/FC gestapelt.' },
        iser: { name: 'iSCSI/RDMA (iSER)', desc: 'iSCSI mit dem Datenpfad auf RDMA verlagert — beliebige Fabric (InfiniBand, iWARP, RoCE). Von NVMe/RDMA überholt, in Arrays und in ESXi noch präsent.' },
        srp: { name: 'SCSI/RDMA (SRP)', desc: 'Natives SCSI über RDMA, die Ära vor iSER: InfiniBand (mit Fabric-Discovery) und RoCE — überlebt in betagtem HPC-Storage.' },
        nvmerdma: { name: 'NVMe/RDMA', desc: 'Entferntes NVMe über jede RDMA-Fabric — InfiniBand, iWARP, RoCE v1 und v2: eine einzige Konfiguration, der Knoten meldet, welche er hat.' },
        s3: { name: 'S3', desc: 'S3-kompatibler Object Storage — Images und Backups.' }
      }
    },
    catalogs: {
      title: 'Kataloge',
      createTitle: 'Katalog erstellen',
      editTitle: 'Katalog bearbeiten',
      docTitle: 'Katalog',
      notFound: 'Diesen Katalog gibt es nicht (mehr?)',
      scopeHint: 'Wer diesen Scope liest, sieht (und kann nutzen) jede Datei des Katalogs',
      files: 'Dateien',
      noFiles: 'Keine Dateien',
      count: {
        iso: 'ISO',
        ctRootfs: 'CT-Tpl',
        vmTemplate: 'VM-Tpl',
        ociImage: 'OCI',
        firmwareOvmf: 'Firmware'
      },
      systemChip: 'System',
      systemTooltip: 'Systemkatalog: Er beherbergt die eingebetteten Objekte der Plattform und lässt sich nicht ändern'
    },
    catalogFiles: {
      catalog: 'Katalog',
      kindLabel: 'Typ',
      physicalSize: 'Physische Größe',
      virtualSize: 'Virtuelle Größe',
      importTemplateAction: 'Als VM Template importieren',
      importTemplateLegacy: 'Kein deklariertes Format — als Festplatten-Seed nutzbar, nicht importierbar',
      importTemplateTitle: 'Als VM Template importieren',
      importTemplateSubmit: 'Importieren',
      importTemplateError: 'Import fehlgeschlagen',
      importTemplateHint: 'Das .tvtpl-Paket wird zu einem VM Template: die eingefrorene Hardware des Manifests plus eine Festplatte je Archiv-Entry, jede gegen ihre Checksumme verifiziert. NICs und CD-/DVD-Medien sind nicht Teil eines Archivs — fügen Sie sie nach dem Import hinzu.',
      importTemplateQcow2Hint: 'Ein nacktes qcow2 wird zu einem Template mit EINER Festplatte und der deklarierten Default-Hardware: Profil linux, UEFI, 2 vCPU, 2048 MiB, Boot von seiner einzigen Festplatte. Beim Deploy anpassen.',
      importTemplateName: 'Template-Name',
      importTemplateNameHint: 'Leer = {name} (-import-<n>, wenn vergeben)',
      importTemplateStorage: 'Storage für die Festplatten',
      importTemplateMetadataStorage: 'Metadaten-Storage',
      importTemplateMetadataHint: 'Ein Block-Storage beherbergt keine VM-Metadaten (Firmware, Varstore) — wählen Sie einen vom Typ dir/nfs/cifs.',
      importTemplateStarted: 'Import gestartet — das Template erscheint im Templates-Tab, wenn der Task abschließt.',
      kind: {
        iso: 'ISO-Image',
        'ct-rootfs': 'CT-Rootfs',
        'vm-template': 'VM-Template',
        'oci-image': 'OCI-Image',
        'firmware-ovmf': 'OVMF-Firmware'
      },
      title: {
        iso: 'ISO-Images',
        'ct-rootfs': 'CT-Templates',
        'vm-template': 'VM-Templates',
        'oci-image': 'OCI-Images',
        'firmware-ovmf': 'OVMF-Firmware'
      },
      createTitle: {
        iso: 'ISO-Image hinzufügen',
        'ct-rootfs': 'CT-Template registrieren',
        'vm-template': 'VM-Template hinzufügen',
        'oci-image': 'OCI-Image hinzufügen',
        'firmware-ovmf': 'OVMF-Firmware hinzufügen'
      },
      formatHint: 'Aus der Endung der gewählten Datei abgeleitet — korrigieren Sie es, wenn es falsch geraten hat',
      tarballHint: 'Ein Rootfs-Tarball im Standard-LXC-Format (.tar.gz / .tar.xz / .tar.zst / .tar.bz2, oder ein schlichtes .tar)',
      ociArchiveHint: 'Ein docker-archive-/oci-archive-Tarball (.tar oder .tar.gz), zum Beispiel aus docker save',
      uploadResumeHint: 'Upload unterbrochen — die Datei wartet auf den Upload: Senden Sie erneut mit derselben Datei, um fortzusetzen',
      moveTitle: 'Datei verschieben',
      moveHint: 'Zwei unabhängige Dimensionen: Katalog verschiebt die Verknüpfung (gleiche id, kein Byte bewegt sich, der Scope wird der des Zielkatalogs); Storage verschiebt die Daten — jede verknüpfte Kopie folgt, abgelehnt, solange die Datei in Benutzung ist. Zusammen gewählt: zuerst der Katalog, dann der Storage.',
      moveCatalog: 'Zielkatalog',
      moveCatalogHint: 'Nur die Verknüpfung wechselt ihr Zuhause: eine VM, die die Datei eingehängt hat, muss den Zielkatalog sehen können',
      keepCurrent: 'Nicht ändern',
      rehomed: 'Verknüpfung in den gewählten Katalog verschoben',
      copyAction: 'In einen Katalog kopieren…',
      copyTitle: 'In einen Katalog kopieren',
      copyLinkHint: 'Die Kopie ist eine neue Verknüpfung auf dieselben Daten — auf dem Storage wird nichts dupliziert.',
      copyCatalog: 'Zielkatalog',
      copyCatalogHint: 'Kopieren ist der Weg, auf dem eine Datei zwischen Katalogen reist',
      sameCatalog: 'Derselbe wie die Quelle',
      sharedObjectHint: 'Die Daten dieser Datei werden von {count} verknüpften Kopien geteilt',
      deleteLastLink: 'Dies ist die LETZTE Verknüpfung zu diesem Inhalt: Auch die Daten werden vom Storage gelöscht.',
      deleteLinkOnly: 'Nur diese Verknüpfung wird entfernt — die Daten bleiben, weiterhin erreichbar über die anderen verknüpften Kopien ({count}).',
      noCatalog: 'Es gibt noch keinen Katalog — legen Sie einen an',
      inlineCatalogName: 'Katalogname',
      embeddedChip: 'eingebettet',
      embeddedStorage: 'In die Plattform eingebettet',
      embeddedNoMove: 'Eingebettete Plattformdatei: Sie lebt auf keinem Storage — klonen Sie sie stattdessen',
      embeddedCopyHint: 'Der Klon materialisiert die eingebetteten Bytes auf einem echten Storage: Wählen Sie Ziel-Storage und Katalog — die Kopie ist eine gewöhnliche Datei',
      sourceEmbedded: 'In die Plattform eingebettet',
      nodesRow: 'Vorhandensein je Knoten',
      nodesSummary: '{present} von {total} Knoten haben es',
      nodePresent: 'vorhanden',
      nodeMissing: 'fehlt',
      nodeUnknown: 'noch nicht gemeldet',
      nodesHint: 'Das Asset liegt auf der Platte jedes Knotens (Paket trantor-tvirt-assets): ein Knoten ohne dieses Asset kann weder eine VM mit dieser Firmware definieren noch die Guest Tools bereitstellen. Unterschiedliche Versionen auf den Knoten sind während eines Rolling-Updates normal.',
      downloadAction: 'Herunterladen',
      downloadNotReady: 'Der Inhalt ist noch nicht bereit — der Download verlangt eine Datei im Zustand ready',
      downloadDenied: 'Ihre Rolle enthält catalog.download nicht — die Bytes herunterzuladen ist ein eigenes Recht, getrennt vom Nutzen der Datei',
      objectRow: 'Storage-Objekt',
      objectLinksRow: 'Verknüpfte Kopien',
      declaredChecksum: 'Deklarierte SHA-256',
      usedByRow: 'Verwendet von',
      usedByVms: 'VMs',
      usedByDisks: 'Festplatten',
      transferRow: 'Übertragung',
      storageLockHint: 'Ändert sich nur über die Aktion Verschieben'
    },
    objects: {
      action: 'Inhalte erkunden',
      title: 'Inhalte des Storage',
      hint: 'Bestandsaufnahme (nur Lesen) dessen, was auf diesem Storage lebt — jedes Objekt wird aus seiner eigenen Sektion verwaltet.',
      empty: 'Kein Objekt auf diesem Storage registriert',
      loadError: 'Die Inhalte konnten nicht geladen werden',
      colDetail: 'Detail',
      manage: 'In seiner Sektion verwalten',
      kind: {
        disk: 'Festplatte',
        catalogFile: 'Katalogdatei',
        ociBlob: 'OCI-Blob',
        checkpoint: 'Checkpoint',
        vmMetadata: 'VM-Metadata',
        appRoot: 'App-Root',
        appVolume: 'App-Volume'
      }
    },
    inventory: {
      tabCatalogs: 'Kataloge',
      storage: 'Storage',
      sizeGib: 'Größe (GiB)',
      format: 'Format',
      size: 'Größe',
      sourceType: 'Quelle',
      sourceFile: 'Datei-Upload',
      sourceUrl: 'Download von URL',
      file: 'Datei',
      url: 'URL',
      checksum: 'SHA-256-Checksumme',
      checksumHint: 'Erforderlich: Der Download wird gegen diese SHA-256 verifiziert',
      verifyChecksum: 'Checksumme verifizieren',
      checksumOffHint: 'Der Download wird ohne Verifikation akzeptiert — die berechnete SHA-256 wird trotzdem aufgezeichnet',
      uploading: 'Wird hochgeladen…',
      move: {
        action: 'Verschieben',
        diskTitle: 'Festplatte verschieben',
        target: 'Ziel-Storage',
        diskHint: 'Die Festplatte behält ihre Identität: Die Bytes reisen auf den gewählten Storage. Eine VM, die sie nutzt, muss ausgeschaltet sein; mit vorhandenen Snapshots lehnt eine iSCSI-Seite die Verschiebung ab.',
        noTargets: 'Kein kompatibler Ziel-Storage',
        submit: 'Verschieben',
        error: 'Die Verschiebung wurde abgelehnt'
      },
      clone: {
        action: 'Klonen',
        title: 'Festplatte klonen',
        name: 'Name der Kopie',
        storage: 'Ziel-Storage',
        sameStorage: 'Derselbe wie die Quelle',
        linked: 'Linked Clone',
        linkedHint: 'Sofortiges qcow2-Overlay, an die Quellfestplatte gekettet (nur qcow2-Quellen). Der Default ist eine vollständige Kopie.',
        linkedCrossHint: 'Ein Linked Clone bleibt auf dem Storage der Quelle: Wählen Sie "Derselbe wie die Quelle", um ihn zu aktivieren.',
        submit: 'Klonen',
        error: 'Das Klonen wurde abgelehnt'
      },
      copy: {
        action: 'Kopieren',
        name: 'Name der Kopie',
        storage: 'Ziel-Storage',
        sameStorage: 'Derselbe wie die Quelle',
        submit: 'Kopieren',
        error: 'Die Kopie wurde abgelehnt'
      },
      taskStarted: 'Gestartet — läuft als Task im Hintergrund weiter',
      cephObjects: 'Zu den Objekt-Details auf Ceph',
      phase: {
        ready: 'Bereit',
        creating: 'Wird erstellt',
        'awaiting-upload': 'Wartet auf Upload',
        downloading: 'Wird heruntergeladen',
        verifying: 'Wird verifiziert',
        deleting: 'Wird gelöscht',
        error: 'Fehler',
        'in-use': 'In Benutzung'
      }
    }
  }
}
